import React from 'react';
import { formatCurrency } from '../../../../utils/formatting';
import type { PixHeaderProps } from '../types/pix-payment.types';

const PixHeader: React.FC<PixHeaderProps> = ({ customerName, totalAmount }) => {
  return (
    <div className="text-center mb-8">
      <h2 className="text-2xl sm:text-3xl font-bold text-primary mb-2">
        Pague com PIX para Finalizar seu Pedido!
      </h2>
      <p className="text-text-secondary dark:text-gray-300">
        Olá, {customerName}! Seu pedido no valor de <strong className="text-text-primary dark:text-gray-100">{formatCurrency(totalAmount)}</strong> está quase pronto.
      </p>
    </div>
  );
};

export default PixHeader; 